import type { InjectionKey, Ref } from 'vue'

interface DshSelectGroupContext {
  disabled: boolean
}

export interface DshQueryChangeCtx {
  query: string
}

export interface DshSelectContext {
  props: {
    multiple?: boolean
    multipleLimit?: number
    valueKey?: string
    modelValue?: string | number | unknown | unknown[]
    popperClass?: string
    remote?: boolean
    fitInputWidth?: boolean
  }
  queryChange: Ref<DshQueryChangeCtx>
  groupQueryChange: Ref<string>
  selectWrapper: HTMLElement
  cachedOptions: Map<any, any>
  hoverIndex: number
  optionsCount: number
  filteredOptionsCount: number
  options: Map<any, any>
  optionsArray: any[]
  selected: any | any[]
  setSelected(): void
  onOptionCreate(vm: DshSelectOptionProxy): void
  onOptionDestroy(key: number | string | Record<string, any>): void
  handleOptionSelect(vm: unknown): void
}

// For individual build sharing injection key, we had to make `Symbol` to string
export const dshSelectGroupKey: InjectionKey<DshSelectGroupContext> =
  Symbol('ElDshSelectGroup')

export const dshSelectKey: InjectionKey<DshSelectContext> =
  Symbol('ElDshSelect')

export interface DshSelectOptionProxy {
  value: string | number | Record<string, string>
  label: string | number
  created: boolean
  disabled: boolean
  currentLabel: string
  itemSelected: boolean
  isDisabled: boolean
  select: DshSelectContext
  hoverItem: () => void
  visible: boolean
  hover: boolean
  selectOptionClick: () => void
}
